export default __webpack_public_path__ + "static/media/crypto-traders.3ae45457.png";